import { render, staticRenderFns } from "./ContentGuide.vue?vue&type=template&id=130e87f3&scoped=true&"
import script from "./ContentGuide.vue?vue&type=script&lang=js&"
export * from "./ContentGuide.vue?vue&type=script&lang=js&"
import style0 from "./ContentGuide.vue?vue&type=style&index=0&id=130e87f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130e87f3",
  null
  
)

export default component.exports